import r from "../../shared-lib/braze-shared-lib.js";
export default class FeatureFlag {
  constructor(t, r = !1, e = {}) {
    (this.id = t), (this.enabled = r), (this.properties = e);
  }
  getStringProperty(t) {
    if (!this.yr(t)) return null;
    const r = this.properties[t];
    return this.Er(r, "string") ? r.value : null;
  }
  getNumberProperty(t) {
    if (!this.yr(t)) return null;
    const r = this.properties[t];
    return this.Er(r, "number") ? r.value : null;
  }
  getBooleanProperty(t) {
    if (!this.yr(t)) return null;
    const r = this.properties[t];
    return this.Er(r, "boolean") ? r.value : null;
  }
  ss() {
    const t = {};
    return (
      (t[FeatureFlag.hs.ns] = this.id),
      (t[FeatureFlag.hs.Fe] = this.enabled),
      (t[FeatureFlag.hs.we] = this.properties),
      t
    );
  }
  yr(t) {
    return (
      !(!this.properties || !this.properties[t]) ||
      (r.D.info(`${t} not found in feature flag properties.`), !1)
    );
  }
  Er(t, e) {
    return (
      (t.type === e && typeof t.value === e) ||
      (r.D.info(`Property is not of type ${e}.`), !1)
    );
  }
}
(FeatureFlag.hs = { ns: "id", Fe: "e", we: "pr" }),
  (FeatureFlag.At = { ns: "id", Fe: "enabled", we: "properties" });
